export class TenantLink {
  tenantId: string;
  type: string;
  linkId: string;
  preText: string;
  text: string;
  postText: string;
  linkHref: string;
}
